__turbopack_context__.v({
  "childrenWrapper": "index-module__U6b05q__childrenWrapper",
  "icon": "index-module__U6b05q__icon",
  "tooltip": "index-module__U6b05q__tooltip",
});
